import { clearAuthCookie, redirectToCognitoLogout } from '../utils/cognitoAuth';

const useAuth = () => {
  /**
   * Handle user logout
   *
   * @return {void}
   * */
  const handleLogout = () => {
    clearAuthCookie();
    redirectToCognitoLogout();
  };

  return {
    handleLogout,
  };
};

export default useAuth;
